module.exports = __webpack_public_path__ + "static/img/guide-03.891ab128.png";